/**
 * User role enum for Flutter app compatibility
 */
export var UserRole;
(function (UserRole) {
    UserRole["ADMIN"] = "ADMIN";
    UserRole["USER"] = "USER";
    UserRole["MODERATOR"] = "MODERATOR";
    UserRole["TRAINER"] = "TRAINER";
})(UserRole || (UserRole = {}));
export const MEMBER_PLAN_TIERS = ['FREE', 'EFX', 'PREMIUM'];
/** `code` of the 403 a gated endpoint answers with. */
export const ENTITLEMENT_FEATURE_LOCKED = 'entitlement.feature_locked';
export const ENTITLEMENT_DAILY_LIMIT_REACHED = 'entitlement.daily_limit_reached';
